import { icon } from "@fortawesome/fontawesome-svg-core"

export const inventory = [
    {
        _id: 1,
        designation: "Samsumg Galaxy S24",
        category: "Mobile phones",
        brand: "Samsung",
        new: true,
        properties: {
            grade1: {
                ram: "12Gb",
                memory: "512 Gb",
                camera: "50 Mp",
                battery: "4000 MAh",
                cost: 450000,
                discount: 0.15
            },
            grade2: {
                ram: "32Gb",
                memory: "1 Tb",
                camera: "50 Mp",
                battery: "4000 MAh",
                cost: 480000
            }
        },
        images: [
            "./phones/galaxy-s24-front.jpg",
            "./phones/galaxy-s24-back.jpg",
            "./phones/galaxy-s24-side.jpg"
        ]
    },
    {
        _id: 2,
        designation: "Xiomi Redmi note 13",
        category: "Mobile phones",
        brand: "Xiaomi",
        properties: {
            grade1: {
                ram: "12Gb",
                memory: "512 Gb",
                camera: "50 Mp",
                battery: "4000 MAh",
                cost: 400000,
                discount: 0
            },
            grade2: {
                ram: "32Gb",
                memory: "1 Tb",
                camera: "50 Mp",
                battery: "4000 MAh",
                cost: 450000
            }
        },
        images: [
            "./phones/redmi-note-13-img1.jpg",
            "./phones/redmi-note-13-img2.png",
            "./phones/redmi-note-13-img3.jpeg"
        ]
    },
    {
        _id: 3,
        designation: "Samsumg Galaxy S20",
        category: "Mobile phones",
        brand: "Samsung",
        new: true,
        properties: {
            grade1: {
                ram: "12Gb",
                memory: "512 Gb",
                camera: "50 Mp",
                battery: "4000 MAh",
                cost: 450000,
                discount: 0.20
            },
            grade2: {
                ram: "32Gb",
                memory: "1 Tb",
                camera: "50 Mp",
                battery: "4000 MAh",
                cost: 480000
            }
        },
        images: [
            "./phones/samsung-galaxy-s20-1.jpeg",
            "./phones/samsung-galaxy-s20-2.jpeg",
            "./phones/samsung-galaxy-s20-3.jpeg"
        ]
    },
    {
        _id: 4,
        designation: "Google Pixel 6",
        category: "Mobile phones",
        brand: "Google",
        properties: {
            grade1: {
                ram: "12Gb",
                memory: "512 Gb",
                camera: "50 Mp",
                battery: "4000 MAh",
                cost: 450000,
                discount: 0
            },
            grade2: {
                ram: "32Gb",
                memory: "1 Tb",
                camera: "50 Mp",
                battery: "4000 MAh",
                cost: 480000
            }
        },
        images: [
            "./phones/google-pixel-6-1.jpeg",
            "./phones/google-pixel-6-2.jpeg",
            "./phones/google-pixel-6-3.jpeg"
        ]
    },
    {
        _id: 5,
        designation: "Iphone 16",
        category: "Mobile phones",
        brand: "Apple",
        properties: {
            grade1: {
                ram: "12Gb",
                memory: "512 Gb",
                camera: "50 Mp",
                battery: "4000 MAh",
                cost: 450000,
                discount: 0.12
            },
            grade2: {
                ram: "32Gb",
                memory: "1 Tb",
                camera: "50 Mp",
                battery: "4000 MAh",
                cost: 480000
            }
        },
        images: [
            "./phones/iphone-16-1.jpeg",
            "./phones/iphone-16-2.jpg",
            "./phones/iphone-16-3.jpeg"
        ]
    },
    {
        _id: 6,
        designation: "Google Pixel 8",
        category: "Mobile phones",
        brand: "Google",
        new: true,
        properties: {
            grade1: {
                ram: "12Gb",
                memory: "512 Gb",
                camera: "50 Mp",
                battery: "4000 MAh",
                cost: 450000,
                discount: 0
            },
            grade2: {
                ram: "32Gb",
                memory: "1 Tb",
                camera: "50 Mp",
                battery: "4000 MAh",
                cost: 480000
            }
        },
        images: [
            "./phones/google-pixel-8-1.jpg",
            "./phones/google-pixel-8-2.jpeg",
            "./phones/google-pixel-8-3.jpg"
        ]
    },
    {
        _id: 7,
        designation: "Google Pixel 8 Pro",
        category: "Mobile phones",
        brand: "Google",
        properties: {
            grade1: {
                ram: "12Gb",
                memory: "512 Gb",
                camera: "50 Mp",
                battery: "4000 MAh",
                cost: 450000,
                discount: 0.12
            },
            grade2: {
                ram: "32Gb",
                memory: "1 Tb",
                camera: "50 Mp",
                battery: "4000 MAh",
                cost: 480000
            }
        },
        images: [
            "./phones/google-pixel-8-pro-1.jpg",
            "./phones/google-pixel-8-pro-2.jpg",
            "./phones/google-pixel-8-pro-3.jpg"
        ]
    },
    {
        _id: 8,
        designation: "Iphone 17",
        category: "Mobile phones",
        brand: "Apple",
        new: true,
        properties: {
            grade1: {
                ram: "12Gb",
                memory: "512 Gb",
                camera: "50 Mp",
                battery: "4000 MAh",
                cost: 450000,
                discount: 0.12
            },
            grade2: {
                ram: "32Gb",
                memory: "1 Tb",
                camera: "50 Mp",
                battery: "4000 MAh",
                cost: 480000
            }
        },
        images: [
            "./phones/iphone-17-1.jpeg",
            "./phones/iphone-17-2.jpeg",
            "./phones/iphone-17-3.jpg"
        ]
    },

]

export const brands = [
    { name: "Apple", logo: "/logos/apple.png" },
    { name: "Xiaomi", logo: "/logos/xiaomi.png" },
    { name: "Samsung", logo: "/logos/samsung.png" },
    { name: "Google", logo: "/logos/google.png" },
    { name: "Huawei", logo: "/logos/huawei.png" },
    { name: "Motorola", logo: "/logos/motorola.png"}
]

export const categories = [
    { fr: "Téléphones portables", icon: "/logos/mobile-phone.png", name: 'Mobile phones' },
    { fr: "Écouteurs intra-auriculaires", icon: "/logos/air-pods.png", name: 'Ear buds' },
    { fr: 'Tablettes', icon: '/logos/tablet.png', name: 'Tablets'},
    { fr: "Écrans tactiles", icon: "/logos/screen.png", name: "Touch Screen" },
    { fr: "Chargeurs", icon: "/logos/charger.png", name: 'Chargers' },
    { fr: "Accessoires", icon: "/logos/appliances.png", name: "Accessories"}
]